import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type PersistentPreferencesState = {
    uiLocale?: string;
};

const initialState: PersistentPreferencesState = {};

const preferencesSlice = createSlice({
    name: "persistentPreferences",
    initialState,
    reducers: {
        setUiLocale(state, action: PayloadAction<string>) {
            state.uiLocale = action.payload;
        },
    },
});

export const { setUiLocale } = preferencesSlice.actions;
export const preferences = preferencesSlice.reducer;
